import {
  getUser as getUserRepo,
  updateSecuritySettings,
} from "@/services/api/UserRepository";
import type { UserSecurity } from "@/types/model/User";
import { useUsersStore } from "@/zustand/usersStore";
import { useLoaderStore } from "@/zustand/loaderStore";
import { useNotificationStore } from "@/zustand/notificationsStore";
import { userIsDemo } from "@/utilities/planHelpers";

let userPromise: Promise<void> | null = null;

export const getUser = () => {
  if (userPromise) return userPromise;
  userPromise = getUserRepo()
    .then((res) => {
      if (!res) {
        return;
      }
      // this is something related to old permissions to show checkbox only to bemobi
      useUsersStore.getState().setUser(res.data);
    })
    .catch(() => {})
    .finally(() => {
      userPromise = null;
    });
  return userPromise;
};

export function updateUserSecurity(settings: UserSecurity) {
  const user = useUsersStore.getState().user;

  if (userIsDemo(user)) {
    useNotificationStore
      .getState()
      .warning("This action is not allowed in Demo accounts");
    useLoaderStore.getState().setLoading(false);
    return;
  }

  updateSecuritySettings(settings)
    .then(() => {
      useNotificationStore.getState().success("Password successfully updated");
    })
    .catch(() => {
      useNotificationStore.getState().error("Failed to update password");
    })
    .finally(() => {
      useLoaderStore.getState().setLoading(false);
    });
}
